import type { Feature, FeatureModule } from '../../../types';
import { featureList } from '../../helpers';
import { PAYMENTS_ACTIVITY_FEATURE_GROUP } from './group';

export const PAYMENTS_ACTIVITY_FEATURES = {
  READ: {
    guid: 'b1f0c3a4-5d62-4e78-9a01-3c7d5e9f0600',
    name: 'payments_activity:read',
    description: 'View the payments activity feed',
    action: 'read',
    product: 'payments',
    parentGuid: PAYMENTS_ACTIVITY_FEATURE_GROUP.guid,
  },
} as const satisfies Record<string, Feature>;

export { PAYMENTS_ACTIVITY_FEATURE_GROUP } from './group';

export const PAYMENTS_ACTIVITY_MODULE: FeatureModule = {
  product: 'payments',
  groups: [PAYMENTS_ACTIVITY_FEATURE_GROUP],
  features: featureList(PAYMENTS_ACTIVITY_FEATURES),
};
